export default {
  primary: '#ff5d28',
  secondary: '#676767',
  primaryGradient: {
    rgb: 'rgb(254,185,104)',
    gradient: 'linear-gradient(135deg, rgba(254,185,104,1) 0%, rgba(253,134,92,1) 100%)'
  },
  mtRed: 'rgb(208, 18, 27)', // mtロゴの色
  orange: 'rgba(255,93,40,1)',
  clearOrange: 'rgba(255,93,40,.6)',
  moreClearOrange: 'rgba(255,93,40,.3)',
  background: {
    orange: '#ffddd0',
    lightgray: '#efefef',
  },
  text: {
    orange: '#f53c00',
  },
  white: '#FFFFFF',
  gray: '#808080',
  lightgray: '#dddddd',
  blue: '#005FFF',
  green: '#008000',
  itemCategories: {
    healthy: '#1959ab',
    healthy_large: '#1959ab',
    protein: '#f1a625',
    care: '#ec85b9',
    extra: '#ec85b9',
    selection: '#00a337',
  },
  temperature: {
    frozen: '#cf121a', // 多分いらなくなる
    normal: '#00a337' // 多分いらなくなる
  },
  quantity_terms: {
    setOnly: '#cf121a', // ７商品以上組み合わせてご注文可能
    single: '#00a337' //   1商品からでも注文可能
  }
}
